import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { onChangeIsochronesFilter } from '../../../ac/onChangeMapFilters';
import { isochroneFilterValues, isochronesWithScootersFilterValues } from '../../../constants/variables';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { ColoredItemsLegend } from '../../LegendRenderer/types/ColoredItemsLegend';
import { LEGEND_ICON_TYPES } from '../../../types/legendTypes';
import { StandardRadioGroup } from '../StandardRadioGroup';
import styles from '../FilterSidebar.module.css';


const IsochronesFilterComponent = ({
    onChangeIsochronesFilter,
    parkingIsochrones,
}) => (
    <div>
        <div className={styles.legHead}>{t`Изохроны доступности парковок`}:</div>
        <StandardRadioGroup
            value={String(parkingIsochrones)}
            onChange={({ target: { value } }) => onChangeIsochronesFilter({ target: { value: +value } })}
        >
            {
                isochroneFilterValues.map(value => (
                    <FormControlLabel
                        key={value}
                        className={styles.isochroneFilterLabel}
                        control={
                            <Radio
                                checked={parkingIsochrones === value}
                                onChange={onChangeIsochronesFilter}
                                value={value}
                                className={classnames(
                                    styles.isochroneFilterInput, {
                                        [styles.checkedIsochroneFilterInput]: parkingIsochrones === value,
                                    }
                                )}
                                size='small'
                            />
                        }
                        label={t`${value}м`}
                        labelPlacement='end'
                    />
                ))
            }
        </StandardRadioGroup>
    </div>
);
const IsochronesLegendComponent = () => (
    <div>
        <ColoredItemsLegend
            items={isochronesWithScootersFilterValues.map(({ label, fill }) => ({
                id: fill,
                label: { id: `label_${fill}`, message: i18n._(label) },
                fill,
            }))}
            icon={LEGEND_ICON_TYPES.CIRCLE}
            renderConfig={{
                showIcon: true,
                iconSize: '30px',
                iconOpacity: 0.8,
                fontSize: '0.85rem',
            }}
        />
    </div>
);
const mapStateToProps = ({ mapFilters: { parkingIsochrones } }) => ({ parkingIsochrones });
const ConnectedComponent = connect(mapStateToProps, { onChangeIsochronesFilter })(IsochronesFilterComponent);

export const IsochronesFilter = withDisplayedLayersCheck(ConnectedComponent, t`Изохроны доступности парковок`);
export const ServiceCentersIsochronesLegend = withDisplayedLayersCheck(IsochronesLegendComponent, t`Изохроны доступности парковок`);
